import { TabError } from '@/utils/class/TabError'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getSpecificBasicData } from '@/utils/basicDataCache'
import { ensureExecuteSuccess } from '@/utils/commonUtil'
import { isArray } from '@/utils/validate'
import strUtils from '@/utils/StrUtils'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import * as BillReleaseType from '@/class/cargo/model/parameters/BillReleaseType'
import { DocCommon } from '@/class/cargo/model/utils/DocCommon'
import { ContainerUtil } from '@/class/cargo/model/utils/ContainerUtil'
import { SeaExportUtils } from '@/class/cargo/model/utils/SeaExportUtils'
import { Company } from '@/class/model/mdm/Company'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { SeaCargoDoc } from '@/class/model/booking/SeaCargoDoc'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { surrendered, postRemotingTracking } from '@/api/seaExport/seaCargoDoc'
import { EDIContainer } from '@/class/model/booking/EDIContainer'
import * as VirtualBillType from '@/class/cargo/model/parameters/VirtualBillType'
import { unJointSlavesHawb2 } from '@/api/seaExport/seaExportJob'
import { getExChangeAgent } from '@/api/partner/overseaAgent'
import * as BillType from '@/class/cargo/model/parameters/BillType'
import * as CargoDocCfmState from '@/class/cargo/model/parameters/CargoDocCfmState'
import { getLoading } from '@/utils/utilBaseElement'
import ColumnUtils from '@/utils/ColumnUtils'
import { PrintUtils } from '@/utils/PrintUtils'
import { CargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'

export class TabSubBillPM {
  /**
  * @param {Object} view 视图
  */
  constructor(view) {
    this.view = view
    this.$message = view.$message
    this._seaeqNumber = ''
    this.originalPrintCheckSerialNo = false // 提单流水号打印验证
  }
  get context() {
    return this.view.context
  }
  set context(context) {
    // 不可赋值
  }
  get config() {
    return this.view.context.config
  }
  set config(config) {
    this.view.context.config = config
  }
  get job() {
    return this.view.job
  }
  set job(job) {
    this.view.job = job
  }
  get form() {
    return this.view.form
  }
  set form(form) {
    this.view.form = form
  }
  get packingList() {
    return this.view.context.packingList
  }
  set packingList(packingList) {
    // 不可赋值
  }
  /**
   * init
   */
  async init() {
    this.originalPrintCheckSerialNo = Number(this.config.get('originalPrintCheckSerialNo')) === 1
    this.view.maxChars = Number(this.config.get('SEShipperConsigneNotifyMaxchars'))
    this.printParam4Type = [
      { label: '', data: '' },
      { label: 'AS CARRIER', data: 'AS CARRIER' },
      { label: 'AS AGENT FOR THE CARRIER', data: 'AS AGENT FOR THE CARRIER' },
      { label: 'AS AGENT FOR ', data: 'AS AGENT FOR ' }
    ]
    this.printParam5Type = [
      { label: '', data: '' },
      { label: 'SEABRIDGE FCL', data: 'DELIVERY ORDER FEE ON ACCOUNT OF CNEE' },
      { label: 'SEABRIDGE LCL NORMAL', data: 'DESTINATION CFS CHARGES INCL.DELIVERY ORDER FEE AND GSC CHARGES ON ACCOUNT OF CNEE' },
      { label: 'SEABRIDGE LCL INCLUDE CISF', data: 'DESTINATION CFS CHARGES INCL.DELIVERY ORDER FEE AND GSC CHARGES AND CISF ON ACCOUNT OF CNEE' }
    ]
    await getSpecificBasicData(basicCacheKeys.basic_data_BlMode).then(data => {
      for (const item of data) {
        if (item.blType === 3) {
          const blMode = this.view.blModeList.find(p => p.uuid === item.uuid)
          if (!blMode) {
            this.view.blModeList.push(item)
          }
        }
      }
    })
  }
  // 加载普单数据
  async loadByNormal() {
    const subBillCargoDocs = []
    const cargoDocList = this.job.seaCargoDoc
    if (cargoDocList && cargoDocList.length > 0) {
      for (const cd of cargoDocList) {
        if (cd.docType === CargoDocConsts.HAWB2) {
          if (this.view.isEdit) {
            if (this.view.autoIncrementNum) { // 编辑时，增加临时序号
              cd.temporarySerialNumber = this.view.autoIncrementNum.getNextNum()
            }
          }
          subBillCargoDocs.push(cd)
        }
      }
    }
    this.view.bill.rowData = subBillCargoDocs
    if (subBillCargoDocs.length > 0) {
      this.form = subBillCargoDocs[0]
      this.view.$nextTick(async() => {
        await ensureExecuteSuccess(() => this.view.bill.gridApi)
        const gridApi = this.view.bill.gridApi
        const nodes = gridApi.getRenderedNodes()
        nodes[0].setSelected(true)
      })
      this.cmbissuerHBLChangeHandler()
    } else { // 不存到数据库
      this.form = new SeaCargoDoc().fillDefaultValue().getData()
      this.form.issuerBL = this.view.defaultIssuerBL
    }
    const hblNoList = []
    if ([BillType.SPLIT_BILL_TYPE.code, BillType.MERGE_BILL_TYPE.code].includes(this.job.typeHBL)) {
      for (const item of cargoDocList) {
        if (item.docType === CargoDocConsts.HBL2 && item.hblNbr2) {
          hblNoList.push({ code: item.hblNbr2 })
        }
      }
    } else {
      for (const item of cargoDocList) {
        if (item.docType === CargoDocConsts.HBL && item.hblNbr2) {
          hblNoList.push({ code: item.hblNbr2 })
        }
      }
    }
    this.view.hblNoList = hblNoList
    this.view.$nextTick(async() => {
      await ensureExecuteSuccess(() => this.view.bill.gridApi)
      let selectedNode = null
      const { rowsToDisplay } = this.view.bill.gridApi.getModel()
      if (this.view.curBill) {
        selectedNode = rowsToDisplay.find(node => node.data.hblNbr2 === this.view.curBill.hblNbr2) || rowsToDisplay[0]
      } else {
        selectedNode = rowsToDisplay[0]
      }
      const selectedData = selectedNode ? selectedNode.data : (this.view.billFinalRowData && this.view.billFinalRowData.length > 0 ? this.view.billFinalRowData[0] : null)
      if (selectedData) {
        selectedNode.setSelected(true)
        await this.dgBill_changeHandler(selectedData)
      }
    })
    await this.loadCommonInformation()
  }
  // 加载并单数据
  async loadByMerge() {
    const subBillCargoDocs = []
    const cargoDocList = this.job.seaCargoDoc
    if (cargoDocList && cargoDocList.length > 0) {
      for (const cd of cargoDocList) {
        if (cd.docType === CargoDocConsts.HAWB2) {
          if (this.view.isEdit) {
            if (this.view.autoIncrementNum) { // 编辑时，增加临时序号
              cd.temporarySerialNumber = this.view.autoIncrementNum.getNextNum()
            }
          }
          subBillCargoDocs.push(cd)
        }
      }
    }
    if (subBillCargoDocs.length > 0) {
      this.form = subBillCargoDocs[0]
    } else { // 不存到数据库
      this.form = new SeaCargoDoc().fillDefaultValue().getData()
      this.form.issuerBL = this.view.defaultIssuerBL
    }
    const jointSlavesHAWB2 = await new SeaExportJob(this.job).getJointSlavesHAWB2()
    this.loadJointSlavesHAWB2Handler(jointSlavesHAWB2)
    await this.loadCommonInformation()
  }
  // 加载普单，并单通用的信息
  async loadCommonInformation() {
    await this.checkCmbtypeHAWB2Enabled()
    new SeaCargoDoc(this.form).getEdiContainer().then(data => {
      this.view.container.rowData = data
    })
    this._seaeqNumber = ContainerUtil.getSeaeqNumberStr(this.job)
    this.view.lblCfrState = ColumnUtils.cfmStatusLabelFunc(this.form.cfmState)
    this.view.billLadingIssued = ColumnUtils.bliStatusLabelFunc(this.form.bliStatus)
    this.refreshVessel()
  }
  fillModel(cargoDoc) {
    if (!cargoDoc) {
      return
    }
    const packing = this.context.packingList.find(p => p.code === cargoDoc.packing)
    if (packing) {
      cargoDoc.quantitySum = strUtils.jsdx(cargoDoc.quantity, packing.name)
    } else {
      cargoDoc.quantitySum = ''
    }
    cargoDoc.containerSum = this._seaeqNumber
    if (cargoDoc.state === 0) {
      cargoDoc.state = 1
    }
    JobUtils.handlingSpecialCharactersForCargoDoc(cargoDoc)
  }
  validateForm(cargoDoc) {
    if (cargoDoc.releaseType && cargoDoc.releaseType === BillReleaseType.SURRENDERED.code) {
      const regexp = /^\W*to\W*-?\W*order\W*$/i
      const _txtconsigneeLine1 = cargoDoc.consigneeLine1.toLocaleLowerCase()
      if (regexp.test(_txtconsigneeLine1)) {
        throw new TabError(this.view.$t('Message.TOORDERIsUnavailableToRelease'), 'tabSubBill')
      }
    }
  }
  refreshVessel() {
    if (this.job.barge && this.form.printParam6) {
      this.view.txtFirstVesselVoyage = this.job.bargeVessel || ''
      this.view.txtFirstVesselVoyage += ' '
      this.view.txtFirstVesselVoyage += this.job.bargeVoyage || ''
    } else {
      this.view.txtFirstVesselVoyage = this.job.vessel || ''
      this.view.txtFirstVesselVoyage += ' '
      this.view.txtFirstVesselVoyage += this.job.voyageFlight || ''
    }
  }
  /**
 * 抄录收货人
 */
  onCopy_consignee() {
    this.form.notifyCode = this.form.consigneeCode
    this.form.notifyLine1 = this.form.consigneeLine1
    this.form.notifyLine2 = this.form.consigneeLine2
    this.form.notifyLine3 = this.form.consigneeLine3
    this.form.notifyLine4 = this.form.consigneeLine4
    this.form.notifyLine5 = this.form.consigneeLine5
    this.form.notifyLine6 = this.form.consigneeLine6
    this.form.notifyLine7 = this.form.consigneeLine7
  }
  /**
 * 抄录上次
 */
  onCopy1() {
    this.form.shipperCode = DocCommon.HBL_History.shipperCode || ''
    this.form.shipperLine1 = DocCommon.HBL_History.shipperLine1 || ''
    this.form.shipperLine2 = DocCommon.HBL_History.shipperLine2 || ''
    this.form.shipperLine3 = DocCommon.HBL_History.shipperLine3 || ''
    this.form.shipperLine4 = DocCommon.HBL_History.shipperLine4 || ''
    this.form.shipperLine5 = DocCommon.HBL_History.shipperLine5 || ''
    this.form.shipperLine6 = DocCommon.HBL_History.shipperLine6 || ''
    this.form.consigneeCode = DocCommon.HBL_History.consigneeCode || ''
    this.form.consigneeLine1 = DocCommon.HBL_History.consigneeLine1 || ''
    this.form.consigneeLine2 = DocCommon.HBL_History.consigneeLine2 || ''
    this.form.consigneeLine3 = DocCommon.HBL_History.consigneeLine3 || ''
    this.form.consigneeLine4 = DocCommon.HBL_History.consigneeLine4 || ''
    this.form.consigneeLine5 = DocCommon.HBL_History.consigneeLine5 || ''
    this.form.consigneeLine6 = DocCommon.HBL_History.consigneeLine6 || ''
    this.form.notifyCode = DocCommon.HBL_History.notifyCode || ''
    this.form.notifyLine1 = DocCommon.HBL_History.notifyLine1 || ''
    this.form.notifyLine2 = DocCommon.HBL_History.notifyLine2 || ''
    this.form.notifyLine3 = DocCommon.HBL_History.notifyLine3 || ''
    this.form.notifyLine4 = DocCommon.HBL_History.notifyLine4 || ''
    this.form.notifyLine5 = DocCommon.HBL_History.notifyLine5 || ''
    this.form.notifyLine6 = DocCommon.HBL_History.notifyLine6 || ''
    this.form.cargoEnglishName = DocCommon.HBL_History.englishCargoName || ''
    this.form.mark = DocCommon.HBL_History.mark || ''
  }
  selectionItemHandler(rows) {
    const selectedHBL = isArray(rows) ? rows[0] : rows
    if (selectedHBL && Object.keys(selectedHBL).length > 0) {
      this.form.shipperCode = selectedHBL.shipperCode
      this.form.shipperLine1 = selectedHBL.shipperLine1
      this.form.shipperLine2 = selectedHBL.shipperLine2
      this.form.shipperLine3 = selectedHBL.shipperLine3
      this.form.shipperLine4 = selectedHBL.shipperLine4
      this.form.shipperLine5 = selectedHBL.shipperLine5
      this.form.shipperLine6 = selectedHBL.shipperLine6

      this.form.consigneeCode = selectedHBL.consigneeCode
      this.form.consigneeLine1 = selectedHBL.consigneeLine1
      this.form.consigneeLine2 = selectedHBL.consigneeLine2
      this.form.consigneeLine3 = selectedHBL.consigneeLine3
      this.form.consigneeLine4 = selectedHBL.consigneeLine4
      this.form.consigneeLine5 = selectedHBL.consigneeLine5
      this.form.consigneeLine6 = selectedHBL.consigneeLine6

      this.form.notifyCode = selectedHBL.notifyCode
      this.form.notifyLine1 = selectedHBL.notifyLine1
      this.form.notifyLine2 = selectedHBL.notifyLine2
      this.form.notifyLine3 = selectedHBL.notifyLine3
      this.form.notifyLine4 = selectedHBL.notifyLine4
      this.form.notifyLine5 = selectedHBL.notifyLine5
      this.form.notifyLine6 = selectedHBL.notifyLine6

      this.form.cargoEnglishName = this.job.cargoEnglishName
      this.form.mark = this.job.mark
    }
  }
  /**
 * 锁定按钮处理
 */
  onState() {
    if (!this.form.uuid) return
    surrendered({ cargoDocUuid: this.form.uuid, cfmState: this.form.cfmState, state: 1, releaseState: this.form.releaseState }).then(res => {
      if (res.data) {
        this.form.state = res.data.state
        this.form.version = res.data.version
        this.unLockCargoDocHandler()
      }
    })
  }
  /**
 * 解锁
 */
  unLockCargoDocHandler() {
    this.job.printHblZbLock = false
    this.loadJointSlaves2Handler()
  }
  /**
   *  提单类型
   */
  cmbreleaseTypeMBLChangeHandler(val) {
    if (Number(val) === 1) {
      this.form.blNumber = 'THREE'
    } else {
      this.form.blNumber = 'ONE'
    }
  }
  loadJointSlaves2Handler(result) {
    this.printStateChange()
  }
  printStateChange() {
    this.view.btnPrintDisabled = true
    if (this.view.isEdit) {
      return
    }
    // 是否异地放单 ,如果是TRUE，正本打印、电放按钮无法打印
    if (this.form.oversea && this.form.releaseType === 1) {
      return
    }
    if (this.form.releaseType === 1) {
      if (this.view.$checkPermission(['button_printDoc'])) {
        if ([0, 1].includes(this.form.state)) {
          this.view.btnPrintDisabled = false
        }
      }
    } else if (this.form.releaseType === BillReleaseType.SURRENDERED.code) {
      // 有权限才行
      if (this.view.$checkPermission(['button_HBL_surrender'])) {
        this.view.btnPrintDisabled = false
      }
    } else {
      this.view.btnPrintDisabled = false
    }
    if (this.job.shutOut && !this.view.btnPrintDisabled) {
      this.view.btnPrintDisabled = true
    }
  }
  /**
   * clear input
   */
  onClear(type) {
    switch (type) {
      case 1:
        this.form.shipperCode = ''
        this.form.shipperLine1 = ''
        this.form.shipperLine2 = ''
        this.form.shipperLine3 = ''
        this.form.shipperLine4 = ''
        this.form.shipperLine5 = ''
        this.form.shipperLine6 = ''
        this.form.shipperLine7 = ''
        break
      case 2:
        this.form.consigneeCode = ''
        this.form.consigneeLine1 = ''
        this.form.consigneeLine2 = ''
        this.form.consigneeLine3 = ''
        this.form.consigneeLine4 = ''
        this.form.consigneeLine5 = ''
        this.form.consigneeLine6 = ''
        this.form.consigneeLine7 = ''
        break
      case 3:
        this.form.notifyCode = ''
        this.form.notifyLine1 = ''
        this.form.notifyLine2 = ''
        this.form.notifyLine3 = ''
        this.form.notifyLine4 = ''
        this.form.notifyLine5 = ''
        this.form.notifyLine6 = ''
        this.form.notifyLine7 = ''
        break
      case 4:
        this.form.agentPartyLine1 = ''
        this.form.agentPartyLine2 = ''
        this.form.agentPartyLine3 = ''
        this.form.agentPartyLine4 = ''
        this.form.agentPartyLine5 = ''
        this.form.agentPartyLine6 = ''
        this.form.agentPartyLine7 = ''
        break
      default:
        break
    }
  }
  // 复制主单收货人
  async onCopy_agentParty() {
    const mdoc = await new SeaExportJob(this.job).getMainMbl()
    if (mdoc) {
      this.form.agentPartyLine1 = mdoc.consigneeLine1
      this.form.agentPartyLine2 = mdoc.consigneeLine2
      this.form.agentPartyLine3 = mdoc.consigneeLine3
      this.form.agentPartyLine4 = mdoc.consigneeLine4
      this.form.agentPartyLine5 = mdoc.consigneeLine5
      this.form.agentPartyLine6 = mdoc.consigneeLine6
    }
  }
  // '取指定货代理信息
  onCopy_designationAgent() {
    const cpy = this.context.companyList.find(p => p.cmpIdx === this.job.designationAgent)
    if (cpy) {
      new Company(cpy).getOverseaAgentDetail().then(data => {
        this.loadDestinationAgentHandler(data)
      })
    }
  }
  loadDestinationAgentHandler(overseaAgentDetail) {
    if (overseaAgentDetail) {
      this.form.agentPartyLine1 = overseaAgentDetail.blAddress
      this.form.agentPartyLine2 = overseaAgentDetail.blAddressLine2
      this.form.agentPartyLine3 = overseaAgentDetail.blAddressLine3
      this.form.agentPartyLine4 = overseaAgentDetail.blAddressLine4
      this.form.agentPartyLine5 = overseaAgentDetail.blAddressLine5
      this.form.agentPartyLine6 = overseaAgentDetail.blAddressLine6
    }
  }
  cmbissuerHBLChangeHandler(data) {
    if (data) {
      this.form.issuerBL = data.value
    }
    if (this.form.issuerBL) {
      if (this.form.issuerBL === 'TH') {
        this.view.hblNoDisabled = false
      } else {
        this.view.hblNoDisabled = parseInt(this.config.get('SEAllowEditHBLNo')) !== 1
      }
    }
    this.printStateChange()
  }
  chargeContainer() {
    if (this.job.containerLoadType === 'BB') {
      this.form.container = SeaExportUtils.getContainerDesc(this.job, this.form.printParam3)
    }
  }
  /**
 * 取MBL信息
 */
  async getMBLInfo(type) {
    await new SeaExportJob(this.job).getSeaCargoDoc()
    let mbl = null
    for (const doc of this.job.seaCargoDoc) {
      if (doc.docType === CargoDocConsts.MBL) {
        mbl = doc
        break
      }
    }
    if (mbl) {
      if (type === 'mark') {
        this.form.mark = mbl.mark
      } else if (type === 'EName') {
        this.form.cargoEnglishName = mbl.cargoEnglishName
      }
    }
  }
  /**
 * 新增形式分单
 */
  async newSubBillHandler() {
    const job = new SeaExportJob(this.job)
    const cargoDocs = await job.getSeaCargoDoc()
    let newDoc = null
    let hbl = await job.getCargoDocByDocType(CargoDocConsts.HBL)
    if (!hbl) {
      hbl = await job.getCargoDocByDocType(CargoDocConsts.HBL2)
    }
    if (!hbl) {
      newDoc = await job.getCargoDocByDocType(CargoDocConsts.HAWB2, true)
    } else {
      newDoc = new SeaCargoDoc().fillDefaultValue()
      newDoc.issuerBL = this.view.defaultIssuerBL
      new SeaCargoDoc(newDoc).copyBasic(hbl)
      newDoc = newDoc.getData()
      newDoc.docType = CargoDocConsts.HAWB2
      if (this.config.get('ToExoSystem') === 'JYD') {
        newDoc.notifyCode = ''
        newDoc.notifyLine1 = 'SAME AS CONSIGNEE'
        newDoc.notifyLine2 = ''
        newDoc.notifyLine3 = ''
        newDoc.notifyLine4 = ''
        newDoc.notifyLine5 = ''
        newDoc.notifyLine6 = ''
        newDoc.notifyLine7 = ''
      }
    }
    newDoc.paymentTerm = Number(this.config.get('MemoBillDefaultValue')) === 1 ? '' : job.paymentTermHBL
    newDoc.dispatchingPlaceCode = job.dispatchingPlaceCode
    newDoc.loadingPortCode = job.loadingPortCode
    newDoc.dischargingPortCode = job.dischargingPortCode
    newDoc.destinationPortCode = job.destinationPortCode
    // CARGO-42736 集翊达形式分单取值逻辑更改
    await this.initDocInfo(newDoc, job)
    newDoc.jobUuid = job.uuid
    if (Number(this.config.get('syncSignDateBl')) === 1) {
      newDoc.signDateBL = job.atd
    } else {
      newDoc.signDateBL = job.etd
    }
    newDoc.temporarySerialNumber = this.view.autoIncrementNum.getNextNum()
    // 设置分单号
    if (this.config.get('ToExoSystem') === 'JYD') {
      if (job.typeVirtualHbl === VirtualBillType.NORMAL_VIRTUAL_BILL_TYPE.code) {
        const rowData = this.view.bill.rowData.filter(p => !p.deleted)
        if (rowData.length > 0) {
          if (rowData.length === 1 && rowData[0].hblNbr2 === job.jobNo + 'M') {
            rowData[0].hblNbr2 = job.jobNo + 'M-1'
          }
          let num = rowData.length + 1
          let newHblNbr2 = job.jobNo + 'M-' + num
          while (rowData.findIndex(p => p.hblNbr2 === newHblNbr2) >= 0) {
            num += 1
            newHblNbr2 = job.jobNo + 'M-' + num
          }
          newDoc.hblNbr2 = newHblNbr2
        } else {
          newDoc.hblNbr2 = job.jobNo + 'M'
        }
      } else {
        newDoc.hblNbr2 = job.jobNo + 'M'
      }
    } else {
      const prefix = job.jobNo + '-'
      let curCode = 0
      for (const item of this.view.bill.rowData) {
        const hblNbr2 = item.hblNbr2
        if (hblNbr2.startsWith(prefix)) {
          const code = Number(hblNbr2.substr(prefix.length))
          if (code && code > curCode) {
            curCode = code
          }
        }
      }
      newDoc.hblNbr2 = job.jobNo + '-' + (curCode + 1)
    }
    // 判断是否有形式分单
    let isFound = false
    if (cargoDocs) {
      for (const item of cargoDocs) {
        // 忽略掉被删除的
        if (item.deleted) {
          continue
        }
        if (item.docType === CargoDocConsts.HAWB2) {
          if (job.typeVirtualHbl === VirtualBillType.NORMAL_VIRTUAL_BILL_TYPE.code) { // 普单
            if (item.temporarySerialNumber === newDoc.temporarySerialNumber) {
              isFound = true
              break
            }
          } else if (job.typeVirtualHbl === VirtualBillType.MERGE_VIRTUAL_BILL_TYPE.code) { // 并单
            isFound = true
            break
          }
        }
      }
    }
    if (!isFound) {
      job.seaCargoDoc.push(newDoc)
    }
    if (job.typeVirtualHbl === VirtualBillType.NORMAL_VIRTUAL_BILL_TYPE.code) { // 普单
      this.view.bill.rowData.push(newDoc)
      this.form = newDoc
      this.view.curBill = newDoc
      setTimeout(() => {
        this.setSelectNode(0)
      }, 100)
    } else { // 并单
      this.form = newDoc
    }
    this.dgBill_changeHandler(this.form)
    await this.checkCmbtypeHAWB2Enabled()
  }
  setSelectNode(index) {
    const selectedNode = this.view.bill.gridApi.getModel().rowsToDisplay[index]
    if (selectedNode) {
      this.form = selectedNode.data
      selectedNode.setSelected(true)
      this.view.curBill = this.form
      // CARGO-20371处理形式分单点击新增，从HBL同步收发通数据时，HBL收发通信息有第7行数据问题
      const result = this.mergeShipperLine()
      this.view.splitShipperLine(result)
    }
  }
  /*
    CARGO-20371
    处理形式分单点击新增，从HBL同步收发通数据时，HBL收发通信息有第7行数据问题
  */
  mergeShipperLine() {
    let result = ''
    for (let i = 1; i < 7; ++i) {
      result += this.form['shipperLine' + i] || ''
      result += '\n'
    }
    return result + (this.form['shipperLine7'] || '')
  }
  /**
 * 删除形式分单
 */
  async delSubBillHandler() {
    const selectedRows = this.view.bill.gridApi.getSelectedRows()
    const row = selectedRows.length ? selectedRows[0] : null
    if (!row) {
      return
    }
    if (row.uuid) {
      row.deleted = true
      const tempRowData = this.view.bill.rowData
      this.view.bill.rowData = []
      if (this.job.seaCargoDoc && this.job.seaCargoDoc.length > 0) {
        for (const cargoDoc of this.job.seaCargoDoc) {
          if (cargoDoc.uuid && cargoDoc.uuid === row.uuid) {
            cargoDoc.deleted = true
            break
          }
        }
      }
      this.view.$nextTick(() => {
        this.view.bill.rowData = tempRowData
      })
    } else {
      // 移除列表
      const index = this.view.bill.rowData.findIndex(p => p.temporarySerialNumber === row.temporarySerialNumber)
      if (index > -1) {
        this.view.bill.rowData.splice(index, 1)
      }
      // 移除Job中的数据
      if (this.job.seaCargoDoc && this.job.seaCargoDoc.length > 0) {
        const index = this.job.seaCargoDoc.findIndex(p => p.temporarySerialNumber === row.temporarySerialNumber && p.docType === CargoDocConsts.HAWB2)
        if (index > -1) {
          this.job.seaCargoDoc.splice(index, 1)
        }
      }
    }
    //
    if (this.view.billFinalRowData.length > 0) {
      this.form = this.view.billFinalRowData[0]
      this.view.curHbl = this.form
    } else {
      this.form = new SeaCargoDoc().fillDefaultValue().getData()
      this.view.curBill = null
    }
    this.dgBill_changeHandler(this.form)
    await this.checkCmbtypeHAWB2Enabled()
  }
  setDefaultSelect() {
    if (this.view.billFinalRowData.length > 0) {
      this.form = this.view.billFinalRowData[0]
      this.view.$nextTick(() => {
        this.view.bill.gridApi.setFocusedCell(0)
      })
    } else {
      // 不存到数据库
      this.form = new SeaCargoDoc().fillDefaultValue().getData()
      this.form.issuerBL = this.view.defaultIssuerBL
    }
    if (this.form.releaseType === 1) {
      this.form.blNumber = 'THREE'
    } else {
      this.form.blNumber = 'ONE'
    }
    if (this.view.bill.rowData && this.view.bill.rowData.length <= 0) {
      this.form.blNumber = ''
    }
    this.editingChanged()
  }
  dgBill_changeHandler(data) {
    if (!data) {
      return
    }
    this.form = data
    this.view.curBill = this.form
    if (this.form.releaseType === 1) {
      this.form.blNumber = 'THREE'
    } else {
      this.form.blNumber = 'ONE'
    }
    this.editingChanged()
    this.cmbissuerHBLChangeHandler()
    new SeaCargoDoc(this.form).getEdiContainer().then(data => {
      this.view.container.rowData = data
    })
    this.docCfmStateChanged()
    this.docBliStatusChanged()
  }
  editingChanged() {
    this.view.$nextTick(() => {
      this.loadJointSlaves2Handler()
    })
  }
  addContainerUsageClickHandler() {
    this.view.cargoDocUsageSelectedDialog.visible = true
  }
  async removeContainerUsageClickHandler() {
    const rows = this.view.container.gridApi.getSelectedRows()
    if (rows.length === 0) {
      this.view.$message.warning(this.view.$t('SeaExport.PleaseSelectRemovedContainer'))
      return
    }
    for (const row of rows) {
      if (row.uuid) {
        row.deleted = true
        const tempRowData = this.view.container.rowData
        this.view.container.rowData = []
        await this.view.$nextTick(async() => {
          this.view.container.rowData = tempRowData
        })
      } else {
        const index = this.view.container.rowData.findIndex(p => p === row)
        if (index >= 0) {
          this.view.container.rowData.splice(index, 1)
        }
      }
    }
    await this.refreshSeqContainer()
    this.refreshEdiContainerGrid()
  }
  async usageSelectCallBackFunc(usages) {
    this.view.container.rowData = await new SeaCargoDoc(this.form).getEdiContainer()
    this.addUsageForGrid(usages)
    await this.refreshSeqContainer()
    this.refreshEdiContainerGrid()
    this.view.cargoDocUsageSelectedDialog.visible = false
  }
  async refreshSeqContainer() {
    this.form.seaeq = SeaExportUtils.getJoinSeaDocSeaEQDesc(this.form, this.job, this.form.printParam1, 'Part of')
    this.form.container = await SeaExportUtils.getContainerQWCDesc(this.form, this.form.printParam3)
  }
  // 添加装箱信息
  addUsageForGrid(usages) {
    if (usages && usages.length > 0) {
      for (const item of usages) {
        if (!this.existContainerUsage(item)) {
          const ec = new EDIContainer().fillDefaultValue().getData()
          ec.deleted = false
          ec.containerNo = item.container.containerNo
          ec.sealNo = item.container.sealNo
          ec.eqType = item.container.eqType
          ec.eqSize = item.container.eqSize
          ec.quantity = item.quantity
          ec.weight = item.weight
          ec.cubage = item.cubage
          ec.cargoDocUuid = this.form.uuid
          ec.containerUsageUuid = null
          this.view.container.rowData.push(ec)
        }
      }
    }
  }
  // 验证是否已存在
  existContainerUsage(u) {
    for (const item of this.view.container.rowData) {
      if (u.container.eqSize === item.eqSize && u.container.eqType === item.eqType &&
          u.container.containerNo === item.containerNo && u.container.sealNo === item.sealNo) {
        return true
      }
    }
    return false
  }
  // 刷新当前提单的货物信息
  refreshEdiContainerGrid() {
    if (this.view.isXy) {
      return
    }
    const rowData = this.view.container.rowData
    if (rowData) {
      let quantity = 0
      let weight = 0.000
      let cubage = 0.000
      for (const container of rowData) {
        if (!container.deleted) {
          quantity += container.quantity
          weight += container.weight
          cubage += container.cubage
        }
      }
      this.form.quantity = quantity
      this.form.weight = weight
      this.form.cubage = cubage
      CargoDocUtil.calculateSEChargeWeight(this.form)
    } else {
      // 移除完箱子后清空件毛体
      this.form.quantity = 0
      this.form.weight = 0
      this.form.cubage = 0
      this.form.chargeWeight = 0
    }
  }
  // 检查是否禁用选择形式分单种类
  async checkCmbtypeHAWB2Enabled() {
    this.view.cmbtypeHAWB2Disabled = false
    if (!this.job.uuid) {
      this.view.cmbtypeHAWB2Disabled = true
      return
    }
    if (Number(this.job.typeVirtualHbl) === VirtualBillType.MERGE_VIRTUAL_BILL_TYPE.code) {
      if (this.job.jointSlavesHAWB2 && this.job.jointSlavesHAWB2.length > 0) {
        this.view.cmbtypeHAWB2Disabled = true
      } else {
        if (this.view.virtualMergeBill.rowData && this.view.virtualMergeBill.rowData.length > 0) {
          this.view.cmbtypeHAWB2Disabled = true
        } else {
          this.view.cmbtypeHAWB2Disabled = this.view.readonly
        }
      }
    } else {
      await this.isEditTypeHAWB2()
    }
  }
  // 形式分单种类是否可编辑
  async isEditTypeHAWB2() {
    if (!this.job.seaCargoDoc || this.job.seaCargoDoc.length <= 0) {
      await new SeaExportJob(this.job).getSeaCargoDoc()
    }
    const cargoDocList = this.job.seaCargoDoc
    if (cargoDocList && cargoDocList.length > 0) {
      if (Number(this.job.typeVirtualHbl) === VirtualBillType.NORMAL_VIRTUAL_BILL_TYPE.code) {
        for (const doc of cargoDocList) {
          if (doc.docType === CargoDocConsts.HAWB2 && !doc.deleted) {
            this.view.cmbtypeHAWB2Disabled = true
            break
          }
        }
      }
    }
  }
  // 选择形式分单并单
  async typeVirtualHblChangeHandler(val) {
    const job = this.job
    // 是否发生变更
    const typeVirtualHblChange = job.typeVirtualHbl !== val
    // 是否有形式分单
    let hasSubBill = false
    const cargoDocList = await new SeaExportJob(job).getSeaCargoDoc()
    for (const cargoDoc of cargoDocList) {
      if (cargoDoc.deleted) {
        continue
      }
      if (CargoDocConsts.HAWB2 === cargoDoc.docType) {
        hasSubBill = true
        break
      }
    }
    // 形式分单种类变更，清除历史的形式分单数据
    if (cargoDocList && cargoDocList.length > 0 && typeVirtualHblChange && hasSubBill) {
      for (let i = cargoDocList.length - 1; i >= 0; --i) {
        const item = cargoDocList[i]
        if (item.docType === CargoDocConsts.HAWB2) {
          item.deleted = true
          if (item.uuid) {
            this.addCargoDocToModifiedSet(item)
          }
          cargoDocList.splice(i, 1)
        }
      }
    }
    job.typeVirtualHbl = val
    if (!hasSubBill || typeVirtualHblChange) { // 形式分单种类变更或者本身没有形式分单数据时，需要新增
      // 新增对应的形式分单数据或者并单数据
      await this.newSubBillHandler()
    }
  }
  // 添加cargoDoc到被修改的集合中
  addCargoDocToModifiedSet(item) {
    const modifiedData = this.context.modifiedData
    modifiedData.seaCargoDoc = modifiedData.seaCargoDoc || []
    const oldItem = modifiedData.seaCargoDoc.find(p => p === item)
    if (oldItem) {
      Object.assign(oldItem, item)
    } else {
      modifiedData.seaCargoDoc.push(item)
    }
  }
  // 加入形式分单并单
  joinVirtualMergeBillHandler() {
    const excludeUuids = Array.from(this.view.virtualMergeBillFinalRowData, p => p.uuid)
    Object.assign(this.view.searchBillNoDialog.params, {
      selectType: 'multiple',
      docType: 'HAWB2',
      job: this.job,
      useDefaultCondition: true,
      excludeUuids
    })
    this.view.searchBillNoDialog.selectHandler = p => { this.selectionItemsHandler(p) }
    this.view.searchBillNoDialog.visible = true
  }
  // 移除形式分单并单
  removeVirtualMergeBillHandler() {
    const doc = this.view.virtualMergeBill.gridApi.getSelectedRows()[0]
    if (doc) {
      this.view.$confirm(
        this.view.$t('Message.AreYouSureYouWantToDelete1') + doc.jobNo + this.view.$t('Message.AreYouSureYouWantToDelete2'),
        this.view.$t('Message.ConfirmDelete'), {
          confirmButtonText: this.view.$t('common.btn.ok'),
          cancelButtonText: this.view.$t('common.btn.cancel'),
          type: 'warning'
        }
      ).then(() => {
        this.onJobsRemoveConfirmed(doc).then()
      }).catch(() => { })
    } else {
      this.$message.warning(this.view.$t('SeaExport.SelectAPieceOfData'))
    }
  }
  async selectionItemsHandler(data) {
    const rowData = this.view.virtualMergeBill.rowData
    const jobKeySet = {}
    for (const seaJob of rowData) {
      jobKeySet[seaJob.uuid] = true
    }
    const selectedJobs = []
    for (const sJob of data) {
      if (!jobKeySet[sJob.uuid]) {
        selectedJobs.push(sJob)
        rowData.push(sJob)
        this.view.addJoinMergeJobList.push({ masterJobUuid: this.job.uuid, key: sJob.uuid, version: sJob.version, type: 'HAWB2' })
      }
    }
    this.view.virtualMergeBill.rowData = [...rowData]
    SeaExportUtils.jointJobsHAWB2(this.job, this.form, selectedJobs)
    await this.checkCmbtypeHAWB2Enabled()
  }
  loadJointSlavesHAWB2Handler(jointSlavesHAWB2) {
    this.view.virtualMergeBill.rowData = jointSlavesHAWB2
    this.printStateChange()
  }
  async onJobsRemoveConfirmed(job) {
    // 先保留原始的值，如果调用后端请求失败，则还原这几个字段
    const oldCargoDoc = {
      quantity: this.form.quantity,
      weight: this.form.weight,
      cubage: this.form.cubage,
      insideQuantity: this.form.insideQuantity
    }
    // 件数
    let quantity = this.form.quantity - job.quantityActual
    // 重量和体积 不加这个校验，是因为三者页面组件不同
    if (quantity < 0) {
      quantity = 0
    }
    // 小件件数
    let insideQuantity = this.form.insideQuantity - job.insideQuantity
    // 重量和体积 不加这个校验，是因为三者页面组件不同
    if (insideQuantity < 0) {
      insideQuantity = 0
    }
    // 重量
    const weight = this.form.weight - job.weightActual
    // 体积
    const cubage = this.form.cubage - job.cubageActual
    // 如果提单是已经真是存在的,此时立即调用移除并单操作，并且已经真实并入的才能调用后台
    if (this.form.uuid && job && job.jointMasterHAWB2Uuid) {
      const params = {}
      params.jobUuid = job.uuid
      params.cargoDoc = {
        cargoDocUuid: this.form.uuid,
        quantity: isNaN(quantity) ? 0 : Number(quantity),
        weight: isNaN(weight) ? 0 : Number(weight),
        cubage: isNaN(cubage) ? 0 : Number(cubage),
        insideQuantity: isNaN(insideQuantity) ? 0 : Number(insideQuantity)
      }
      unJointSlavesHawb2(params).then(res => {
        if (res.data) { // 由于是编辑状态下,所以删除操作成功以后要更新对应的字段以及版本号
          const index = this.view.virtualMergeBill.rowData.findIndex(p => p.uuid === job.uuid)
          if (index >= 0) {
            this.view.virtualMergeBill.rowData.splice(index, 1)
          }
          if (res.data.job) {
            this.job.version = res.data.job.version
            this.job.joinFlagHAWB2 = res.data.job.joinFlagHAWB2
            this.job.jointMasterHAWB2Uuid = res.data.job.jointMasterHAWB2Uuid
            this.view.$emit('syncData', {
              jointMasterHAWB2Uuid: this.job.jointMasterHAWB2Uuid,
              joinFlagHAWB2: this.job.joinFlagHAWB2,
              version: this.job.version
            })
          }
          if (res.data.cargoDoc) {
            this.form.version = res.data.cargoDoc.version
            this.form.quantity = res.data.cargoDoc.quantity
            this.form.insideQuantity = res.data.cargoDoc.insideQuantity
            this.form.weight = res.data.cargoDoc.weight
            this.form.cubage = res.data.cargoDoc.cubage
            this.view.$emit('syncData', { cargoDoc: '', seaCargoDoc: '', isCompleteRow: false })
          }
          this.view.$emit('syncData', { jointSlavesHAWB2: '', isCompleteRow: false })
          if (this.view.virtualMergeBill.rowData.length <= 0) {
            if (this.job.seaCargoDoc && this.job.seaCargoDoc.length > 0) {
              for (const item of this.job.seaCargoDoc) {
                if (item.uuid === res.data.cargoDoc.uuid) {
                  item.deleted = true
                }
              }
            }
          }
          this.checkCmbtypeHAWB2Enabled()
        }
      }).catch(() => {
        this.form.quantity = oldCargoDoc.quantity
        this.form.weight = oldCargoDoc.weight
        this.form.cubage = oldCargoDoc.cubage
        this.form.insideQuantity = insideQuantity
      })
    } else {
      // 移除addJoinMergeJobList中的数据
      const addJoinMergeJobList = this.view.addJoinMergeJobList
      if (addJoinMergeJobList && addJoinMergeJobList.length > 0) {
        for (let i = 0; i < addJoinMergeJobList.length; i++) {
          if (addJoinMergeJobList[i].key === job.uuid) {
            addJoinMergeJobList.splice(i, 1)
            break
          }
        }
      }
      const index = this.view.virtualMergeBill.rowData.findIndex(p => p.uuid === job.uuid)
      if (index >= 0) {
        this.view.virtualMergeBill.rowData.splice(index, 1)
      }
      this.form.quantity = quantity
      this.form.weight = weight
      this.form.cubage = cubage
      this.form.insideQuantity = insideQuantity
      await this.checkCmbtypeHAWB2Enabled()
    }
  }

  /**
   *
   * @returns {Promise<void>}
   */
  async initDocInfo(newDoc, job) {
    const curOffice = this.context.office
    // CARGO-54844 形式分单目前带入数据只会带入收获人和通知人需要把HBL发货人也一起带入
    if (curOffice && this.config.get('ToExoSystem') !== 'HC') {
      newDoc.shipperLine1 = curOffice.seaAddressLine1
      newDoc.shipperLine2 = curOffice.seaAddressLine2
      newDoc.shipperLine3 = curOffice.seaAddressLine3
      newDoc.shipperLine4 = curOffice.seaAddressLine4
      newDoc.shipperLine5 = curOffice.seaAddressLine5
      newDoc.shipperLine6 = curOffice.seaAddressLine6
    }
    // 换单代理
    const exChangeAgentCompany = await Company.getCompanyById(job.exChangeAgent)
    if (exChangeAgentCompany) {
      const exChangeAgent = await getExChangeAgent({ cmpIdx: exChangeAgentCompany.cmpIdx, branchId: curOffice.officeId }).then(res => {
        return res.data ? res.data : null
      })
      if (exChangeAgent) {
        newDoc.consigneeLine1 = exChangeAgent.addressLine1
        newDoc.consigneeLine2 = exChangeAgent.addressLine2
        newDoc.consigneeLine3 = exChangeAgent.addressLine3
        newDoc.consigneeLine4 = exChangeAgent.addressLine4
        newDoc.consigneeLine5 = exChangeAgent.addressLine5
        newDoc.consigneeLine6 = exChangeAgent.addressLine6
        newDoc.consigneeLine7 = exChangeAgent.addressLine7
      }
    }
    // 目的港代理
    const destinationAgent = await Company.getCompanyById(job.destinationAgent)
    if (destinationAgent) {
      const overseaAgent = await new Company(destinationAgent).getOverseaAgentDetail()
      if (overseaAgent) {
        newDoc.agentPartyLine1 = overseaAgent.blAddress
        newDoc.agentPartyLine2 = overseaAgent.blAddressLine2
        newDoc.agentPartyLine3 = overseaAgent.blAddressLine3
        newDoc.agentPartyLine4 = overseaAgent.blAddressLine4
        newDoc.agentPartyLine5 = overseaAgent.blAddressLine5
        newDoc.agentPartyLine6 = overseaAgent.blAddressLine6
        newDoc.agentPartyLine7 = overseaAgent.blAddressLine7
      }
    }
    // 此处将HBL页签货物信息数据同步到形式分单
    const hbl = await job.getCargoDocByDocType(CargoDocConsts.HBL)
    if (hbl) {
      newDoc.insideQuantity = job.insideQuantity
      newDoc.quantity = hbl.quantity
      newDoc.weight = hbl.weight
      newDoc.cubage = hbl.cubage
      newDoc.mark = hbl.mark
      newDoc.cargoEnglishName = hbl.cargoEnglishName
      newDoc.txtQuantitySum = hbl.txtQuantitySum
    }
    if (this.job.typeVirtualHbl !== VirtualBillType.MERGE_VIRTUAL_BILL_TYPE.code && (job.typeHBL === BillType.MERGE_BILL_TYPE.code || job.typeHBL === BillType.SPLIT_BILL_TYPE.code)) {
      const hbl2 = await job.getCargoDocByDocType(CargoDocConsts.HBL2)
      if (hbl2) {
        newDoc.insideQuantity = hbl2.insideQuantity
        newDoc.quantity = hbl2.quantity
        newDoc.weight = hbl2.weight
        newDoc.cubage = hbl2.cubage
        newDoc.mark = hbl2.mark
        newDoc.cargoEnglishName = hbl2.cargoEnglishName
        newDoc.txtQuantitySum = hbl2.txtQuantitySum
      }
    }
  }

  /**
   * 切换形式分单对应hblRefNo时，带入对应单号的货物信息
   * @param p
   * @returns {Promise<void>}
   */
  async onCellChange(p) {
    for (const item of this.job.seaCargoDoc) {
      if (item.hblNbr2 === p.data.hblRefNo) {
        p.data.insideQuantity = this.job.insideQuantity
        p.data.quantity = item.quantity
        p.data.weight = item.weight
        p.data.cubage = item.cubage
        p.data.mark = item.mark
        p.data.cargoEnglishName = item.cargoEnglishName
        p.data.txtQuantitySum = item.txtQuantitySum
        break
      }
    }
  }
  /**
   * 确认对单
   */
  async confirmBL() {
    this.loading = getLoading()
    try {
      if (this.form.cfmState === CargoDocCfmState.CARGODOC_CFM_STATE_YQR.code) {
        this.view.$message.warning(this.view.$t('Message.BlIsConfirmed'))
        return
      }
      this.form.cfmState = CargoDocCfmState.CARGODOC_CFM_STATE_YQR.code
      if (String(this.config.get('ToExoSystem')) === 'TP') {
        await new SeaCargoDoc(this.form).affirmSeaCargoDoc()
      } else {
        await new SeaCargoDoc(this.form).save()
      }
      const newDoc = await SeaCargoDoc.getSeaCargoDoc(this.form.uuid)
      if (newDoc) {
        Object.assign(this.form, newDoc)
      }
      this.docCfmStateChanged()
      this.view.$message.success(this.view.$t('Message.BlIsConfirmed'))
    } finally {
      this.loading.close()
    }
  }
  docCfmStateChanged() {
    const cfmState = CargoDocCfmState.getCargoDocCfmStateByCode(this.form.cfmState)
    if (cfmState) {
      const isZh = this.view.$i18n.locale === 'zh'
      this.view.lblCfrState = isZh ? cfmState.chineseName : cfmState.englishName
    }
  }

  /**
   * 签发提单
   */
  async issuedBL() {
    this.form.bliStatus = CargoDocCfmState.CARGODOC_BLI_STATUS_ISSUED.code
    await new SeaCargoDoc(this.form).save()
    const newDoc = await SeaCargoDoc.getSeaCargoDoc(this.form.uuid)
    if (newDoc) {
      Object.assign(this.form, newDoc)
    }
    this.docBliStatusChanged()
  }
  docBliStatusChanged() {
    const bliStatus = CargoDocCfmState.getCargoDocBliStateByCode(this.form.bliStatus)
    if (bliStatus) {
      const isZh = this.view.$i18n.locale === 'zh'
      this.view.billLadingIssued = isZh ? bliStatus.chineseName : bliStatus.englishName
    }
  }
  print_callback(event) {
    if (event.action === 'print') {
      // CARGO-39566 正本打印/电放打印，不影响 “提单确认状态”状态 （可做平台优化）
      // this.form.cfmState = CargoDocCfmState.CARGODOC_CFM_STATE_RELEASED.code // 已放单
      this.form.state = 2
      this.form.releaseState = 2
      surrendered({ cargoDocUuid: this.form.uuid, cfmState: this.form.cfmState, state: this.form.state, releaseState: this.form.releaseState }).then(res => {
        if (res.data) {
          Object.assign(this.form, res.data)
          this.view.billLadingIssued = ColumnUtils.bliStatusLabelFunc(this.form.bliStatus)
          this.loadJointSlaves2Handler()
        }
      })
      // startCreateFile()
      this.lockBookingTab()
      this.postRemotingTracking('SE-IssueHBL')
    }
  }
  /**
   * 锁定业务页签
   */
  lockBookingTab() {
    this.view.job.printHblZbLock = this.form.state === 2 && Number(this.config.get('HBLPrintLockTab')) === 1
  }
  postRemotingTracking(eventCode) {
    postRemotingTracking({ jobUuid: this.job.uuid, eventCode: eventCode }).then(res => {
    }).finally(() => {
    })
  }
  async v2CheckCallbackFun2(printed, template, entity, params) {
    // this.postRemotingTracking('SE-IssueHBL')
    // 提单状态改为已放单
    if (printed && params.event && params.event.action === PrintUtils.PRINT) {
      // CARGO-39566 正本打印/电放打印，不影响 “提单确认状态”状态 （可做平台优化）
      // this.form.cfmState = CargoDocCfmState.CARGODOC_CFM_STATE_RELEASED.code
      this.form.state = 2
      this.form.releaseState = 2
      surrendered({ cargoDocUuid: this.form.uuid, cfmState: this.form.cfmState, state: this.form.state, releaseState: this.form.releaseState }).then(async res => {
        console.log('surrendered====>res', res)
        if (res.data) {
          Object.assign(this.form, res.data)
          // 修改提单签发状态
          this.view.billLadingIssued = ColumnUtils.bliStatusLabelFunc(this.form.bliStatus)
        }
        this.loadJointSlaves2Handler()
      }).finally(() => {
      })
    } else {
      this.job.cargoDoc = ''
      const jobClass = new SeaExportJob(this.job)
      await jobClass.getCargoDoc()
      this.loadJointSlaves2Handler()
    }
  }
}
